import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LifeBannerPage from './LifeBanner'
import LifeForm from 'components/Forms/LifeSearchForm'
import LifePartners from './LifePartners'
import bannerImage from 'img/motor/motor-main-banner.svg'
import { Modal } from 'antd'

const LifeMainPage = props => {
  const [showModal, setShowModal] = useState(false)

  return (
    <React.Fragment>
      {/* <Navbar /> */}

      <div className="motor">
        <div className="row">
          <div className="col-md-6 col-xs-12 motor_banner_section">
            <LifeBannerPage
              bannerImage={bannerImage}
              moduleName="Car"
              price="GHS 88.00"
            />
          </div>
          <div className="col-md-6 motor_form_section">
            <LifeForm />
          </div>
        </div>

        <div className="row motor_partners_section pb-5rem">
          <div className="col-md-7">
            <LifePartners />
          </div>
        </div>

        <div className="motor_floating_section">
          <button
            type="button"
            className="btn btn--gradient-primary mb-2rem motor_floating_section_button"
            onClick={() => setShowModal(true)}
          >
            Get Started Now
          </button>
        </div>

        <Modal
          title=""
          centered
          width={'90%'}
          visible={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          footer={null}
        >
          <div className="motor_form_wrapper">
            <LifeForm />
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

LifeMainPage.propTypes = {
  match: PropTypes.object
}

export default LifeMainPage
